import './css/header.css';
import logo from './img/ideypay.png';
import { ViewHeadline } from '@material-ui/icons';
import { motion } from 'framer-motion';
import { useState } from 'react';
import { Tooltip } from '@material-ui/core';

export default function Header() {
  const [navbar, setNavBar] = useState("");
  const navToggle = () => {
    navbar === "" ? setNavBar("displayNav") : setNavBar("");
  }

  const hideNavBar = () => {
    setNavBar("");
  }

  return (
      <nav id="navbar">
        <div className="logo">
          <img src={logo} alt="iDeyPay" />
        </div>
        <div className="rightMenu" id={navbar} >
          <Tooltip title="Close">
            <motion.span whileTap={{ scale: 0.8 }} className="close-btn" onClick={() => navToggle()}>X</motion.span>
          </Tooltip>
          <a href="https://ideypay.com/prices" id="menu-item" className="menu-item">Prices</a>
        <a href="https://ideypay.com/about" id="menu-item" className="menu-item">About Us</a>
          <a href="https://support.ideypay.com/" id="menu-item" className="menu-item">Guide</a>
          <a href="https://ideypay.com/login.html" id="menu-item" className="menu-item">Login</a>
          <a href="#getStarted" id="start-link" className="menu-item" onClick={() => hideNavBar()}>Get Started</a>
        </div>
        <motion.div
          className="bars"
          whileTap={{ scale: 0.8 }}
          transition={{ duration: 0.1 }}
          onClick={() => navToggle()}
        >
          <ViewHeadline style={{ color: 'slategray', fontSize: '2.25rem'}} />
        </motion.div>
      </nav>
  )
}
